import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';


export const AccountClientSourceSortCol = {
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TAccountClientSourceSortCol = TTableSortCols<typeof AccountClientSourceSortCol>;

export type TAccountClientSourceQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TAccountClientSourceSortCol;
};

export type TAccountClientSourceQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptAccountClientSourceQueryToRequest(data?: TAccountClientSourceQuery): TAccountClientSourceQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TAccountClientSource = {
  id: number;
  lastName: string;
  firstName: string;
  thirdName?: string;
};

export type TAccountClientSourceResponse = {
  id: number;
  last_name: string;
  first_name: string;
  third_name?: string;
};

export type TAccountClientSourceListResponse = TListResponse<TAccountClientSourceResponse>;

export type TAccountClientSourceList = TListResponse<TAccountClientSource>;

export function adaptAccountClientSourceFromListResponse(data: TAccountClientSourceListResponse): TAccountClientSourceList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptAccountClientSourceFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptAccountClientSourceFromResponse(data: TAccountClientSourceResponse): TAccountClientSource {
	const {
		id,
		last_name: lastName = '',
		first_name: firstName = '',
		third_name: thirdName = '',
	} = data;

	return {
		id,
		lastName,
		firstName,
		thirdName,
	};
}
